<template>
  <div>
    <vs-popup :title="$t('CreateNewTransportTool')" :active.sync="showModal">
      <form class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-2">
          <label class="vs-select--label mb-1">{{
            $t("typeOfTransport")
          }}</label>
          <v-select
            label="typeOfTransport"
            name="typeOfTransport"
            :options="typeOfTransportList"
            :reduce="(x) => x.id"
            v-model="typeOfTransport"
            ref="typeOfTransport"
            dir="rtl"
            :clearable="false"
            v-validate="'required'"
          >
          </v-select>
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('typeOfTransport')"
            >{{ errors.first("typeOfTransport") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.model"
            name="model"
            :label="$t('model')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm my-1" v-show="errors.has('model')">{{
            errors.first("model")
          }}</span>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.nickName"
            name="nickName"
            :label="$t('nickName')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm my-1"
            v-show="errors.has('nickName')"
            >{{ errors.first("nickName") }}</span
          >
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
          <vs-input
            class="inputx"
            v-model="model.plate"
            name="plate"
            :label="$t('plate')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm my-1" v-show="errors.has('plate')">{{
            errors.first("plate")
          }}</span>
        </div>
        <div class="vx-col w-full my-2">
          <vs-button
            type="filled"
            class="float-right my-2 md:w-auto w-full"
            @click.prevent="submitForm"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    model: {
      required: "لطفا مدل را وارد نمایید.",
    },
    plate: {
      required: "لطفا پلاک را وارد نمایید.",
    },
    nickName: {
      required: "لطفا پلاک را وارد نمایید.",
    },
    typeOfTransport: {
      required: "لطفا نوع وسیله حمل و نقل را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "shipping-TransportTools-createPopup",
  props: {
    show: { default: false },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      typeOfTransportList: [
        { typeOfTransport: "کامیون", id: 3 },
        { typeOfTransport: "وانت", id: 2 },
        { typeOfTransport: "موتورسیکلت", id: 1 },
      ],
      model: {},
      typeOfTransport: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createTransportTool_Bike: "shipping/createTransportTool_Bike",
      createTransportTool_PickUp: "shipping/createTransportTool_PickUp",
      createTransportTool_Truck: "shipping/createTransportTool_Truck",
    }),
    isSuccessApi() {
      this.$emit("finish");
      this.model = {};
      this.$validator.reset();
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.model.logisticType = 1;
          if (this.typeOfTransport == 1) {
            this.createTransportTool_Bike(this.model).then(() => {
              this.isSuccessApi();
            });
          }
          if (this.typeOfTransport.id == 2) {
            this.createTransportTool_PickUp(this.model).then(() => {
              this.isSuccessApi();
            });
          }
          if (this.typeOfTransport.id == 3) {
            this.createTransportTool_Truck(this.model).then(() => {
              this.isSuccessApi();
            });
          }
        }
      });
    },
  },
};
</script>
